import Icon from "../../components/Icon"

// Opens the person's one history of their own Rentals money (All Transactions).
// Shown on the Rentals role-selection page and in the tenant view.
function AllTransactionsButton({ onClick, className = "" }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex w-full items-center justify-center gap-1.5 rounded-xl border border-emerald-200 bg-white px-3.5 py-2.5 text-[13px] font-semibold text-emerald-800 shadow-sm transition-colors hover:bg-emerald-50 ${className}`}
    >
      <Icon name="clock-history" size="0.85rem" className="shrink-0" />
      <span>All Transactions</span>
      <Icon name="chevron-right" size="0.7rem" className="shrink-0 text-slate-400" />
    </button>
  )
}

export default AllTransactionsButton
